import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad, { forceCheck } from 'react-lazyload';

/**
 * Docs: https://github.com/jasonslyvia/react-lazyload
 */
const LazyLoadComponent = ({
  children = null,
  height = '100%',
  once = true,
  offset = 200,
  overflow = false,
  placeholder
}) => (
  <LazyLoad
    height={height}
    once={once}
    offset={offset}
    placeholder={placeholder}
    overflow={overflow}
  >
    {children}
  </LazyLoad>
);

/**
 * Manually checks if elements are in viewport
 */
LazyLoadComponent.forceCheck = forceCheck;

LazyLoadComponent.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  offset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  once: PropTypes.bool,
  overflow: PropTypes.bool,
  placeholder: PropTypes.element
};

export default LazyLoadComponent;
